// get the set of month names for the actiuve language
import { useActiveLangStrings } from "./use-active-lang-strings";
export var useDayNamesShort = function () {
  var strings = useActiveLangStrings();
  var dayNames = strings.dayNamesShort || 'Sun_Mon_Tue_Wed_Thu_Fri_Sat_Sun';
  return dayNames.split('_');
};